/** Server answer (409) when the Einsatzteam is absent or double-booked — see server/services/assigneeAvailability.ts. */
export const ASSIGNEE_CONFLICT_CODE = 'assignee_conflict';

export type AssigneeConflictResponse = {
  error: string;
  code: typeof ASSIGNEE_CONFLICT_CODE;
};

/** Reads a 409 assignee conflict without consuming the original response body. */
export async function readAssigneeConflict(res: Response): Promise<AssigneeConflictResponse | null> {
  if (res.status !== 409) return null;
  const data = (await res.clone().json().catch(() => null)) as Partial<AssigneeConflictResponse> | null;
  if (!data || data.code !== ASSIGNEE_CONFLICT_CODE) return null;
  return { error: String(data.error ?? ''), code: ASSIGNEE_CONFLICT_CODE };
}

/** One line per absent / double-booked employee (the server's first line is the heading). */
export function assigneeConflictLines(conflict: AssigneeConflictResponse): string[] {
  return conflict.error
    .split('\n')
    .slice(1)
    .map((line) => line.trim())
    .filter(Boolean);
}
